import React from "react";
import BaseDialog from "./BaseDialog";
import PropertyPanelWidget from "../PropertyPanelWidget";
import SampleDialogDataModel from "../../models/dialog_editor/SampleDialogDataModel";

export default class NewSampleDialogDialog extends BaseDialog {
    /**
     * Dialog for adding a new sample dialog
     * @module NewSampleDialogDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.tempNode = new SampleDialogDataModel("");
        this.tempNode.isEmbed = true;
    }

    /**
     * Handle add to module event
     * @param event
     */
    handleAdd(event) {
        if (!this.tempNode.hasError()) {
            document.dispatchEvent(new CustomEvent("ev-dialog-node-add", {detail: {
                    node: this.tempNode,
                    type: "folder"
                }}));
            w2popup.close();
        } else {
            alert(window.l.popup.fix_error);
        }
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <div className={"container-fluid element-dialog element-body"}>
                    <div className={"row"}>
                        <div className="col-md-12">
                            {<PropertyPanelWidget context={this.tempNode} embed={true}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}